import { render, staticRenderFns } from "./import-bin.vue?vue&type=template&id=4aed388a&"
import script from "./import-bin.vue?vue&type=script&lang=ts&"
export * from "./import-bin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports